import classNames from "classnames";

import styles from "./LikeButtonLarge.module.css";

type Props = {
  liked?: boolean;
  onClick: () => void;
};

export const LikeButtonLarge = ({ liked, onClick }: Props) => {
  const tagClass = classNames(styles.tag, liked ? styles["-active"] : false);

  // LikeButtonLarge
  return (
    <button className={tagClass} onClick={onClick}>
      <span>{liked ? "Du støtter 🤝" : "Støtt dette forslaget"}</span>
    </button>
  );
};
